export default {
  metaDescription: 'Explore career opportunities at PT Tokki Engineering and Fabrication (TEF) and join a growing team in industrial fabrication and engineering.',
  pageTitle: 'Career',
  noOpenings: 'Currently, no job openings are available. Stay tuned!',
  byAdmin: 'By Admin',
  readMore: 'READ MORE',
  modal: {
    department: 'Department',
    location: 'Location',
    level: 'Level',
    jobSummary: 'Job Summary',
    responsibilities: 'Responsibilities',
    requirements: 'Requirements',
    apply: 'Apply',
  },
};
